import React from "react";

function Invoices() {
  return <div className="Invoices">Invoices</div>;
}

export default Invoices;
